import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { LinearProgress } from '@material-ui/core'
import { Page, Header, CustomTable } from 'components'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import VisibilityIcon from '@material-ui/icons/Visibility'

import useRouter from 'utils/useRouter'
import { DetailPanel } from './DetailPanel'

import { FiltrosBancoCadaveres } from './FiltrosBancoCadaveres'
import { useCadaverService } from 'hooks/useCadaverService'
import { useDebounce } from 'hooks/useDebounce'
import useStyles from './styles'

export const BancoDeCadaveres = (props) => {
  const { route } = props
  const dispatch = useDispatch()
  const router = useRouter()
  moment.locale('pt-br', localization)
  const [processandoCadaveres, setProcessandoCadaveres] = useState(false)
  const classes = useStyles()
  const [cadaveres, setCadaveres] = useState([])
  const [cadaveresFiltrados, setCadaveresFiltrados] = useState([])
  const [searchString, setSearchString] = useState('')
  const cadaverService = useCadaverService()

  // Sincroniza a exibição de cadáveres com a listagem filtrada se a busca estiver vazia
  useEffect(() => {
    if (searchString.trim() === '') {
      setCadaveres(cadaveresFiltrados)
    }
  }, [cadaveresFiltrados, searchString])

  // Realiza a busca assíncrona na API com atraso (debounce) de 500ms
  useDebounce(
    async () => {
      if (searchString.trim() !== '') {
        setProcessandoCadaveres(true)
        try {
          const response = await cadaverService.listarCadaveresLikeStringAsync(searchString)
          setCadaveres(response || [])
        } catch (error) {
          console.error('Erro ao buscar cadáveres:', error)
        } finally {
          setProcessandoCadaveres(false)
        }
      }
    },
    500,
    [searchString]
  )

  const handleClickVisualizarPaginaCadaver = (rowData) => {
    router.history.push(`/casos/caso/cadaver/detalhar/${rowData.id}`)
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <FiltrosBancoCadaveres setCadaveres={setCadaveresFiltrados} setProcessandoCadaveres={setProcessandoCadaveres} />
      <div style={{ position: 'relative' }}>
        {processandoCadaveres && (
          <LinearProgress
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 10,
              height: 3,
            }}
          />
        )}
        <CustomTable
          isLoading={false}
          searchPlaceholder="Buscar cadáveres..."
          onSearchChange={(text) => setSearchString(text)}
          localization={{
            body: {
              emptyDataSourceMessage: 'Nenhum cadáver encontrado',
            },
          }}
          columns={[
            {
              title: 'NIC',
              field: 'nic',
              render: (rowData) => rowData.nic,
            },
            {
              title: 'Nome',
              field: 'nome',
              render: (rowData) => (rowData.nome ? rowData.nome : 'Não identificado'),
            },
            {
              title: 'Data de Cadastro',
              field: 'createdAt',
              render: (rowData) => moment(rowData.createdAt).format('LLLL'),
            },
            {
              title: 'Status',
              field: 'status',
              render: (rowData) => `${rowData.status.charAt(0).toUpperCase()}${rowData.status.slice(1).toLowerCase()}`,
            },
          ]}
          detailPanel={(rowData) => <DetailPanel idCadaverSelecionado={rowData.id} />}
          onRowClick={(event, rowData, togglePanel) => togglePanel()}
          data={cadaveres}
          actions={[
            {
              icon: VisibilityIcon,
              tooltip: 'Visualizar página do cadáver',
              onClick: (event, rowData) => handleClickVisualizarPaginaCadaver(rowData),
            },
          ]}
          options={{
            pageSize: 20,
          }}
        />
      </div>
    </Page>
  )
}
